import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { useUpdatePlayer } from "../ApiProvider";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { playerDisplayName } from "../players/PlayerDisplayNameLink";
import { PlayerForm } from "../players/PlayerForm";
/**
 * First-run profile step, shared by fresh signup and the accept-invite bridge.
 * Reuses the standard `PlayerForm` behind a personal welcome; Save and
 * "Skip for now" both call `onDone`, which the caller points at the right
 * destination (Home hub for signup, the joined team for invites).
 */
export const ProfileSetup = ({ player, onDone, }) => {
    const [error, setError] = useState(false);
    const firstName = playerDisplayName(player).split(" ")[0];
    const mutation = useUpdatePlayer({
        id: player.id,
        onMutate: () => setError(false),
        onSuccess: (data) => {
            onDone();
            return data.data;
        },
        onError: () => setError(true),
    });
    return (_jsxs(Box, { sx: { maxWidth: 640, mx: "auto", p: 2 }, children: [_jsxs(Typography, { variant: "h5", sx: { fontWeight: 700 }, children: ["Welcome", firstName ? `, ${firstName}` : "", " \u2014 first, tell us about your soccer profile"] }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mt: 1, mb: 2 }, children: "This helps teammates and managers know your position and style. You can change it anytime." }), _jsx(PlayerForm, { player: player, submitLabel: "Save", cancelLabel: "Skip for now", isSubmitting: mutation.isLoading, onSubmit: (data) => mutation.mutate(data), onCancel: onDone }), _jsx(ErrorSnackbar, { open: error, message: "Failed to save your profile. Please try again.", onClose: () => setError(false) })] }));
};
